import React from 'react';
import { roundAndFormat } from '../../../../lib/utils';
import { Table, TableColumnType } from 'antd';
import { Summary } from '../../../../types/MaterialRequest';

const MaterialRequestSummaryTable = ({
  summaryData,
}: {
  summaryData: Summary[];
}) => {
  const columns: TableColumnType<Summary>[] = [
    {
      title: 'Code',
      dataIndex: 'productCode',
      render: (_text, record) => <span>{record.product.code}</span>,
    },
    {
      title: 'Product',
      dataIndex: 'productName',
      render: (_text, record) => <span>{record.product.description}</span>,
    },
    {
      title: 'UoM',
      dataIndex: 'productUoM',
      render: (_text, record) => <span>{record.productUom.description}</span>,
    },
    {
      title: 'Total Request Quantity',
      dataIndex: 'totalRequestQty',
    },
    {
      title: 'Total Issued Quantity',
      dataIndex: 'totalIssuedQty',
    },
    {
      title: 'Completion %',
      dataIndex: 'completionPercentage',
      render: (_text, record) => (
        <span>{roundAndFormat(record.completionPercentage)}%</span>
      ),
    },
  ];

  return (
    <>
      <Table
        rowKey={(record) => record.id}
        dataSource={summaryData}
        columns={columns}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
      />
    </>
  );
};

export default MaterialRequestSummaryTable;
